import BoletimSection from "../BoletimSection/BoletimSection";
import CardGrid from "../CardGrid/CardGrid";

function LinkPulse({ pulse, title = "Link Pulse" }) {
	const pulseGrades = [
		{
			label: "Empresa",
			value: pulse.empresa ? pulse.empresa : "-",
		},
		{
			label: "Função na empresa",
			value:  pulse.funcao ? pulse.funcao : "-",
		},
		{
			label: "Setor da empresa",
			value:  pulse.setor ? pulse.setor : "-",
		},
		{
			label: "Estágio de negócio",
			value:  pulse.estagio_negocio ? pulse.estagio_negocio : "-",
		},
		{
			label: "Faturamento",
			value:  pulse.faturamento ? pulse.faturamento : "-",
		},
		{
			label: "Já captou",
			value:  pulse.captou ? pulse.captou : "-",
		},
	];
	return (
		<BoletimSection
			title={title}
			icon={"bulb"}
            pill={pulse.period ? pulse.period : false}
		>
			<CardGrid data={pulseGrades} />
		</BoletimSection>
	);
}

export default LinkPulse;
